import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[500px]">
      <div className="lg:w-1/2 relative overflow-hidden bg-accent-100/60">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20reading%20on%20tablet%20device%2C%20beautiful%20illustration%20display%2C%20cozy%20reading%20atmosphere%2C%20warm%20lighting%2C%20webtoon%20style%20art%2C%20digital%20comic%20reading%20scene%2C%20soft%20ambient%20light&width=800&height=700&seq=cta-left-01&orientation=landscape"
          alt="韩漫在线阅读体验"
          title="韩漫漫画网 - 高清流畅阅读"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute top-6 left-6">
          <span className="text-xs text-foreground-600 font-medium bg-background-50/80 px-3 py-1 rounded-full whitespace-nowrap">
            随时随地
          </span>
        </div>
        <div className="absolute bottom-8 left-6">
          <h3 className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 leading-tight whitespace-nowrap">
            高清<br />流畅<br />免费
          </h3>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex flex-col items-center justify-center px-8 md:px-16 py-14">
        <h3 className="text-3xl md:text-5xl font-bold font-heading text-foreground-900 text-center leading-tight mb-6 whitespace-nowrap">
          为什么选择
          <br />
          韩漫漫画网？
        </h3>
        <p className="text-sm md:text-base text-foreground-600 text-center max-w-md leading-relaxed mb-8">
          我们提供超过2500部韩国漫画资源，涵盖八大品类。高清画质搭配极速加载，无需注册即可免费畅享。每日同步更新，让您始终追在最前沿。
        </p>
        <Link
          to="/about"
          className="px-8 py-3 rounded-full bg-secondary-500 text-background-50 text-sm font-semibold hover:bg-secondary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2"
        >
          了解更多
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}